import { unreadonly } from '../../../types/unreadonly';
import type { TableFilterBase } from '../TableFilter';
import {
  NAME_CONTAINS_ANY_OPERATOR,
  NAME_NOT_CONTAINS_ANY_OPERATOR,
} from '../arrayContainsFilterValue';
import { filterOperators } from '../operators';

const labelsFilterOperators = unreadonly([
  'containsAny',
  'notContainsAny',
  NAME_CONTAINS_ANY_OPERATOR,
  NAME_NOT_CONTAINS_ANY_OPERATOR,
  ...filterOperators.empty,
] as const);

export type LabelsFilterOperator = (typeof labelsFilterOperators)[number];

export type LabelsTableFilter = TableFilterBase & {
  type: 'labels';
};

export const createLabelsFilter = (): LabelsTableFilter => ({
  type: 'labels',
  operators: labelsFilterOperators,
});
